
export default {

  computed: {
    getRegionLink() {
      return (region) => {
        if (region.slug === 'paris') {
          return '/paris-75056/';
        }
        return {
          name: 'regions-region-departements-departement',
          params: { region: region.parent.slug, departement: region.slug }
        };
      };
    }
  },

  head() {
    return {
      title: `La région ${this.region.name} - ${this.$config.siteTitle}`,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: ''
        }
      ]
    }
  },


  async asyncData({ params, $axios, $config: { baseApiURL } }) {
    const props = await $axios.$get(`${baseApiURL}/regions/${params.region}`)
    return {
      subRegions: props.subRegions,
      region: props.region,
      breadcrumbs: props.breadcrumbs,
      menu: []
    }
  }

  // create a computed property to conditionally set the url for departements
}
